export default __webpack_public_path__ + "static/media/main_level_test02_kr.e15d71d1.png";